<template>
  <div class="">
    <div class="header_wrapper">
      <div class="title_wrapper">
        <el-image
          class="title_icon"
          src="/img/factoring/custome_title_icon.png"
        ></el-image>
        <div class="title_name">{{ dataInfo.custName }}</div>
        <div class="title_remarks">
          （编号：{{ dataInfo.custNo }} 业务经理：{{
            dataInfo.businessManage
          }}）
        </div>
      </div>
      <a-tabs v-model="activeKeys" @change="handleClick">
        <a-tab-pane
          v-for="(item, index) in tabList"
          :key="index"
          :tab="item.name"
        />
      </a-tabs>
    </div>
    <div class="con_wrapper">
      <keep-alive>
        <component
          :is="componentName()"
          :id="$route.params.id"
          :dataInfo="dataInfo"
          :readOnly="readOnly"
        />
      </keep-alive>
    </div>
  </div>
</template>
<script>
import Overview from "./components/overview/overview";
import HistoryItems from "./components/historyItems/historyItems";
import ServiceManager from "./components/serviceManager/serviceManager";
import Accessory from "./components/accessory/accessory";
import Visit from "./components/visit/visit";
import Assets from "./components/assets/assets";

import Finance from "./components/finance/finance";

import Basic from "./components/basic/basic";

import QuotaContent from "@/views/factoring/quotaManage/component/quotaContent.vue";
import { getCustomerDetail } from "@/api/factoring/factoringCustomer";
import { mapGetters } from "vuex";
export default {
  name: "customerDetail",
  data() {
    return {
      activeKeys: 0,

      tabList: [
        {
          name: "客户概览",
          component: "Overview",
        },
        {
          name: "基本信息",
          component: "Basic",
        },
        {
          name: "客户资产",
          component: "Assets",
        },
        {
          name: "历史项目",
          component: "HistoryItems",
        },
        {
          name: "财务情况",
          component: "Finance",
        },
        {
          name: "额度信息",
          component: "QuotaContent",
        },
        // {
        //   name: "客户评级",
        //   component: "",
        // },
        {
          name: "客户拜访",
          component: "Visit",
        },
        {
          name: "业务经理",
          component: "ServiceManager",
        },
        {
          name: "资料附件",
          component: "Accessory",
        },
      ],
      dataInfo: {},
      readOnly: false,
    };
  },
  components: {
    Overview,
    HistoryItems,
    ServiceManager,
    Accessory,
    Visit,
    Assets,
    Finance,
    Basic,
    QuotaContent,
  },
  computed: {
    ...mapGetters(["userInfo"]),
    componentName() {
      let that = this;
      return function () {
        return that.tabList[that.activeKeys].component;
      };
    },
  },
  async mounted() {
    this.id = this.$route.params.id;
    this.getDetail();

    // let res = await this.queryQuotaDetail(this.id);
    // this.detailData = res[0];
  },

  methods: {
    handleClick(activeKey) {
      if (activeKey == 0 || activeKey == 1) {
        this.getDetail();
      }
    },
    async getDetail() {
      let res = await getCustomerDetail({ id: this.id });
      if (res.data.code == 200) {
        this.dataInfo = res.data.data;
        this.readOnly = this.userInfo.user_id != this.dataInfo.managerUser;
      } else {
        this.$message.error(res.data.message);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.title_wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  color: #333333;
  .title_icon {
    width: 40px;
    height: 40px;
  }
  .title_name {
    margin-left: 6px;
    font-size: 18px;
  }
  .title_remarks {
    margin-left: 2px;
    font-size: 14px;
  }
}
.con_wrapper {
}
.header_wrapper {
  padding: 20px 20px 0 20px;
  background: #fff;
  // height:150px;
}
/deep/ .ant-tabs-bar {
  margin: 0;
}
/deep/ .ant-tabs-nav .ant-tabs-tab {
  font-size: 12px;
  margin-right: 14px;
}
</style>